import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import React from 'react';
import { Box, Chip, icons, Typography } from '@applyboard/ui-components';
var ErrorOutlineIcon = icons.ErrorOutlineIcon,
  CheckCircleIcon = icons.CheckCircleIcon;
var RequirementQuestionStatus = function RequirementQuestionStatus(_ref) {
  var requirement = _ref.requirement,
    rejectedQuestions = _ref.rejectedQuestions,
    layout = _ref.layout,
    onToggleQuestionsModal = _ref.onToggleQuestionsModal;
  var questions = (requirement === null || requirement === void 0 ? void 0 : requirement.application_questions) || [];
  var numQuestions = questions.length;
  var numRejectedQuestions = rejectedQuestions.length;
  var numAcceptedQuestions = questions.filter(function (q) {
    return q.status === 'approved';
  }).length || 0;
  var numAnsweredQuestions = questions.filter(function (q) {
    return q.answers.length > 0;
  }).length || 0;
  var showChips = numRejectedQuestions > 0 || numAcceptedQuestions > 0;
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: layout === 'vertical' ? 'column' : 'row'
  }, /*#__PURE__*/React.createElement(Typography, {
    mr: 1,
    mt: layout === 'vertical' || !showChips ? 0 : 1,
    mb: layout === 'vertical' && showChips ? 0.5 : 0,
    style: {
      fontWeight: 600,
      whiteSpace: 'nowrap'
    }
  }, numAnsweredQuestions, "/", numQuestions, " Question", numAnsweredQuestions === 1 ? '' : 's', ' ', "Answered", showChips ? ':' : ''), showChips && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexWrap: "wrap",
    flexGrow: 1,
    mb: -0.5
  }, numRejectedQuestions > 0 && /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(ErrorOutlineIcon, null),
    color: "negative",
    label: "".concat(numRejectedQuestions, " Answer").concat(numRejectedQuestions === 1 ? '' : 's', " Rejected"),
    mr: 1,
    clickable: true,
    mb: 0.5,
    onClick: onToggleQuestionsModal
  }), numAcceptedQuestions > 0 && /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(CheckCircleIcon, null),
    color: "info",
    label: "".concat(numAcceptedQuestions, " Answer").concat(numAcceptedQuestions === 1 ? '' : 's', " Approved"),
    clickable: true,
    mb: 0.5,
    onClick: onToggleQuestionsModal
  })));
};
export default RequirementQuestionStatus;